
<template>
  <form class="pb-24" @submit.prevent="onSubmit">
    <div class="grid-cols-9 gap-12 pt-4 md:grid md:pt-0">
      <div class="flex col-span-3 md:justify-end"></div>
      <div class="col-span-6">
        <h1 class="font-semibold text-heading text-brand-gray-900">
          {{
            isEditForm
              ? "Úprava přednášky / workshopu"
              : "Registrace přednášky / workshopu"
          }}
        </h1>
      </div>
    </div>
    <div
      v-if="!isEditForm"
      class="grid-cols-9 gap-12 pt-4 mt-8 md:grid md:pt-0"
    >
      <div class="flex col-span-3 md:justify-end"></div>
      <div class="col-span-6">
        <p class="text-body text-brand-gray-900">
          <span class="font-semibold">Chcete letos přednášet?</span>
          Přihlaste si přednášku nebo workshop. O přihlášených výstupech budou
          <a
            class="hover:underline text-brand-blue"
            :href="route('frontend.happening-list')"
            >zde</a
          >
          hlasovat registrovaní účastníci od 20. června. Výsledky hlasování se
          dozvíte 24. července. Výstup s největším počtem hlasů se dostane do
          oficiálního programu ShopCampu.
        </p>
      </div>
    </div>
    <div class="grid-cols-9 gap-12 mt-4 md:mt-12 md:grid">
      <div class="flex col-span-3 md:justify-end">
        <p class="font-semibold uppercase text-brand-orange text-tiny">
          Informace o řečníkovi
        </p>
      </div>
      <div class="col-span-6">
        <p class="mb-12 font-medium text-big-body text-brand-gray-900">
          Nejprve něco málo o vás.
        </p>
        <div class="lg:max-w-[400px] space-y-6">
          <form-input
            :errors="getErrorsFor('name')"
            required
            label="Jméno a příjmení"
            v-model="v$.form.name.$model"
          ></form-input>
          <form-input
            :errors="getErrorsFor('position')"
            required
            label="Kdo jsem, co dělám (pozice)"
            v-model="v$.form.position.$model"
          ></form-input>
          <form-input
            @input="delayTouch(v$.form.email)"
            :errors="getErrorsFor('email')"
            :requiredButHidden="true"
            label="E-mailová adresa"
            type="email"
            v-model="v$.form.email.$model"
          ></form-input>
          <form-input
            :errors="getErrorsFor('phone')"
            :requiredButHidden="true"
            label="Telefonní číslo"
            placeholder="+420"
            v-model="v$.form.phone.$model"
          ></form-input>
          <form-input
            placeholder="https://"
            @input="delayTouch(v$.form.web)"
            :errors="getErrorsFor('web')"
            label="Web"
            v-model="v$.form.web.$model"
          ></form-input>
          <form-input
            @input="delayTouch(v$.form.linkedin)"
            :errors="getErrorsFor('linkedin')"
            label="LinkedIn"
            placeholder="https://www.linkedin.com/"
            v-model="v$.form.linkedin.$model"
          ></form-input>
          <form-input
            @input="delayTouch(v$.form.twitter)"
            :errors="getErrorsFor('twitter')"
            label="Twitter"
            placeholder="https://twitter.com/"
            v-model="v$.form.twitter.$model"
          ></form-input>

          <file-input
            @onFileAdded="onImageAdded"
            @onFileRemoved="onImageRemoved"
            @onImagePreviewLoaded="onImagePreviewLoaded"
          />
        </div>
      </div>
    </div>
    <div class="grid-cols-9 gap-12 mt-4 md:mt-12 md:grid">
      <div class="flex col-span-3 md:justify-end">
        <p class="font-semibold uppercase text-brand-orange text-tiny">
          Informace o přednášce
        </p>
      </div>
      <div class="col-span-6">
        <p class="mb-12 font-medium text-big-body text-brand-gray-900">
          Co byste chtěli sdělit světu české e-commerce?
        </p>
        <div class="max-w-[624px] space-y-6">
          <div>
            <p class="mb-4 font-medium text-body text-brand-gray-900">Typ</p>
            <form-radio
              label="Přednáška"
              radio-id="talk"
              name="type"
              radio-value="talk"
              v-model="form.type"
            ></form-radio>
            <form-radio
              class="mt-4"
              label="Workshop (60 - 90 min)"
              radio-id="workshop"
              name="type"
              radio-value="workshop"
              v-model="form.type"
            ></form-radio>
          </div>

          <transition
            mode="out-in"
            enter-active-class="transition duration-300 ease-out"
            enter-from-class="transform -translate-y-4"
            enter-to-class="transform"
            leave-active-class="transition ease-in duration-250"
            leave-from-class="transform translate-y-4"
            leave-to-class="transform"
          >
            <div v-if="form.type === 'talk'">
              <p class="mb-4 font-medium text-body text-brand-gray-900">
                Typ přednášky
              </p>
              <form-radio
                class="mt-4"
                label="Klasická přednáška (45 min)"
                radio-id="classicTalk"
                name="talkType"
                radio-value="talk"
                v-model="form.talkType"
              ></form-radio>
              <form-radio
                class="mt-4"
                label="Případová studie (15 min)"
                radio-id="caseStudy"
                name="talkType"
                radio-value="caseStudy"
                v-model="form.talkType"
              ></form-radio>
            </div>
          </transition>

          <form-input
            :errors="getErrorsFor('title')"
            required
            label="Název"
            v-model="v$.form.title.$model"
          ></form-input>

          <form-textarea
            :errors="getErrorsFor('annotation')"
            :rows="7"
            label="Anotace"
            secondaryLabel="V ideální délce 3–6 vět."
            v-model="v$.form.annotation.$model"
          />
        </div>
      </div>
    </div>

    <div class="grid-cols-9 gap-12 mt-4 md:mt-12 md:grid">
      <div class="flex col-span-3 md:justify-end">
        <p class="mt-1 font-semibold uppercase text-brand-orange text-tiny">
          Náhled
        </p>
      </div>
      <div class="col-span-6">
        <p class="mb-12 font-medium text-big-body text-brand-gray-900">
          Na závěr si prosím vše zkontrolujte. Takhle vás hlasující uvidí v
          seznamu.
        </p>
        <div class="max-w-[624px]">
          <ProgramCard @clicked="openModal" :programArticle="previewArticle" />
        </div>

        <div v-if="showSuccessMessage" class="col-span-6 mt-8">
          <div class="p-4 rounded-md bg-brand-green">
            <div class="flex items-center">
              <div class="shrink-0">
                <CheckCircleIcon
                  class="w-5 h-5 text-white"
                  aria-hidden="true"
                />
              </div>
              <div class="ml-3">
                <p class="text-sm font-semibold text-white text-body">
                  Úprava přednášky proběhla úspěšně.
                </p>
              </div>
              <div class="pl-3 ml-auto">
                <div class="-mx-1.5 -my-1.5">
                  <button
                    @click="showSuccessMessage = false"
                    type="button"
                    class="
                      inline-flex
                      bg-white
                      rounded-md
                      p-1.5
                      text-brand-green
                      focus:outline-none
                    "
                  >
                    <span class="sr-only">Dismiss</span>
                    <XIcon class="w-5 h-5" aria-hidden="true" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="flex mt-[72px] flex-col md:flex-row items-center justify-end">
      <p class="mb-5 mr-8 font-medium md:mb-0 text-brand-gray-900">
        Vše v pořádku?
      </p>

      <button
        :disabled="formSent"
        class="
          flex
          items-center
          justify-center
          w-full
          px-8
          py-4
          text-white
          transition-all
          duration-200
          ease-out
          rounded-md
          hover:opacity-90
          group
          md:justify-start
          md:w-auto
          text-button
          bg-brand-blue
        "
        type="submit"
      >
        {{ isEditForm ? "Upravit přednášku" : "Přihlásit přednášku" }}
        <svg
          class="
            ml-4
            transition-all
            duration-300
            transform
            group-hover:translate-x-1
          "
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M17.2421 5.99219C17.0929 5.99222 16.947 6.03679 16.8232 6.12019C16.6994 6.20358 16.6033 6.32202 16.5472 6.46033C16.4911 6.59865 16.4776 6.75056 16.5083 6.89662C16.539 7.04269 16.6126 7.17627 16.7197 7.28027L20.4394 11H1.74994C1.65056 10.9986 1.55188 11.017 1.45966 11.054C1.36743 11.0911 1.28349 11.1461 1.21271 11.2159C1.14194 11.2857 1.08573 11.3688 1.04737 11.4605C1.00901 11.5522 0.989258 11.6506 0.989258 11.75C0.989258 11.8494 1.00901 11.9478 1.04737 12.0395C1.08573 12.1312 1.14194 12.2143 1.21271 12.2841C1.28349 12.3539 1.36743 12.4089 1.45966 12.446C1.55188 12.483 1.65056 12.5014 1.74994 12.5H20.4394L16.7197 16.2197C16.6477 16.2888 16.5902 16.3716 16.5506 16.4632C16.511 16.5548 16.4901 16.6534 16.4891 16.7532C16.4881 16.8529 16.507 16.9519 16.5447 17.0443C16.5824 17.1367 16.6382 17.2206 16.7088 17.2912C16.7793 17.3617 16.8633 17.4175 16.9556 17.4552C17.048 17.4929 17.147 17.5118 17.2468 17.5108C17.3466 17.5098 17.4451 17.4889 17.5367 17.4493C17.6283 17.4097 17.7111 17.3523 17.7802 17.2803L22.7802 12.2803C22.9208 12.1396 22.9998 11.9489 22.9998 11.75C22.9998 11.5511 22.9208 11.3604 22.7802 11.2197L17.7802 6.21973C17.7103 6.14773 17.6267 6.0905 17.5342 6.05142C17.4418 6.01233 17.3425 5.99219 17.2421 5.99219Z"
            fill="white"
          />
        </svg>
      </button>
    </div>

    <div class="flex mt-6 flex-col md:flex-row items-center justify-end">
      <p class="text-tiny text-brand-gray-500">
        Beru na vědomí zpracování osobních údajů. Více o tom, jak pracujeme s
        vašimi daty
        <a
          class="text-brand-blue underline"
          :href="route('frontend.gdpr')"
          target="_blank"
          >zde</a
        >.
      </p>
    </div>

    <div
      v-if="showErrorMessage"
      class="grid-cols-9 gap-12 mt-4 md:mt-12 md:grid"
    >
      <div class="flex col-span-3 md:justify-end">
        <p class="mt-1 font-semibold uppercase text-brand-orange text-tiny"></p>
      </div>
      <div class="col-span-6">
        <div class="p-4 rounded-md bg-brand-red">
          <div class="flex items-center">
            <div class="shrink-0">
              <ExclamationIcon class="w-5 h-5 text-white" aria-hidden="true" />
            </div>
            <div class="ml-3">
              <p class="text-sm font-semibold text-white text-body">
                {{
                  isEditForm
                    ? "Úprava přednášky selhala"
                    : "Registrace přednášky selhala."
                }}
              </p>
            </div>
            <div class="pl-3 ml-auto">
              <div class="-mx-1.5 -my-1.5">
                <button
                  @click="showErrorMessage = false"
                  type="button"
                  class="
                    inline-flex
                    bg-white
                    rounded-md
                    p-1.5
                    text-brand-red
                    focus:outline-none
                  "
                >
                  <span class="sr-only">Dismiss</span>
                  <XIcon class="w-5 h-5" aria-hidden="true" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>

  <ProgramCardModal
    @close="() => (modalProgramArticle = undefined)"
    :programArticle="modalProgramArticle"
  />
</template>

<script>
import { computed, ref, onMounted } from "vue";

import FormInput from "../Atomic/Input.vue";
import FileInput from "../Atomic/FileInput.vue";
import FormRadio from "../Atomic/Radio.vue";
import FormTextarea from "../Atomic/Textarea.vue";
import ProgramCard from "../Program/ProgramCard.vue";
import ProgramCardModal from "../Program/ProgramCardModal.vue";

import useVuelidate from "@vuelidate/core";
import { required, email, helpers } from "@vuelidate/validators";

import { CheckCircleIcon, XIcon, ExclamationIcon } from "@heroicons/vue/solid";

import { useReCaptcha } from "vue-recaptcha-v3";

import axios from "axios";

const requiredTranslation = "Toto pole je vyžádováno";
const emailFormatTranslation = "Nesprávný formát e-mailové adresy";

export default {
  components: {
    FormInput,
    FileInput,
    FormRadio,
    FormTextarea,
    ProgramCard,
    CheckCircleIcon,
    XIcon,
    ExclamationIcon,
    ProgramCardModal,
  },
  validations() {
    return {
      form: {
        name: {
          required: helpers.withMessage(requiredTranslation, required),
          $lazy: true,
        },
        position: {
          required: helpers.withMessage(requiredTranslation, required),
          $lazy: true,
        },
        email: {
          $lazy: true,
          email: helpers.withMessage(emailFormatTranslation, email),
          required: helpers.withMessage(requiredTranslation, required),
        },
        phone: {
          required: helpers.withMessage(requiredTranslation, required),
          $lazy: true,
        },
        title: {
          required: helpers.withMessage(requiredTranslation, required),
          $lazy: true,
        },
        annotation: {
          required: helpers.withMessage(requiredTranslation, required),
          $lazy: true,
        },
        web: {
          $lazy: true,
        },
        twitter: {
          $lazy: true,
        },
        linkedin: {
          $lazy: true,
        },
      },
    };
  },

  props: {
    happening: {
      type: Object,
    },

    isEditForm: {
      type: Boolean,
      default: false,
    },

    isAdmin: {
      type: Boolean,
      default: false
    }
  },

  setup({ happening, isEditForm, isAdmin }) {
    onMounted(() => {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);

      edit_token.value = urlParams.get("edit_token");

      if (isEditForm && happening?.speaker?.photo_url) {
        imageSource.value = happening.speaker.photo_url;
      }
    });

    const v$ = useVuelidate({ $lazy: true });
    const touchMap = new WeakMap();
    const showSuccessMessage = ref(false);
    const showErrorMessage = ref(false);
    const formSent = ref(false);
    const modalProgramArticle = ref(undefined);

    const { executeRecaptcha, recaptchaLoaded } = useReCaptcha();

    const edit_token = ref("");

    const getTalkType = () => {
      if (happening.type === "workshop") {
        return undefined;
      }

      return happening.type;
    };

    const getType = () => {
      if (happening.type === "caseStudy") {
        return "talk";
      }

      return happening.type;
    };

    const form = ref({
      name: "",
      email: "",
      phone: "+420",
      web: "",
      twitter: "",
      linkedin: "",
      title: "",
      annotation: "",
      type: "talk", //Talk, Workshop
      talkType: "talk", //caseStudy, talk
      photo: {
        base64: "",
        filename: "",
        type: "",
        size: "",
      },
      position: "",
    });

    if (isEditForm && happening) {
      form.value.name = happening.speaker.name;
      form.value.email = happening.speaker.email;
      form.value.phone = happening.speaker.phone;
      form.value.web = happening.speaker.web;
      form.value.twitter = happening.speaker.twitter;
      form.value.linkedin = happening.speaker.linkedin;
      form.value.title = happening.title;
      form.value.annotation = happening.annotation;
      form.value.type = getType(); //Talk Workshop
      form.value.talkType = getTalkType(); //caseStudy talk
      form.value.position = happening.speaker.position;
    }

    const imageSource = ref("");

    const toBase64 = (file) =>
      new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });

    const onImageAdded = async (file) => {
      if (file) {
        form.value.photo.filename = file.name;
        form.value.photo.type = file.type;
        form.value.photo.size = file.size;
        form.value.photo.base64 = await toBase64(file);
      }
    };

    const onImageRemoved = () => {
      form.value.photo = {
        base64: "",
        filename: "",
        type: "",
        size: "",
      };
    };

    const onImagePreviewLoaded = (src) => {
      imageSource.value = src;
    };

    const getErrorsFor = computed(() => (fieldName) => {
      if (v$.value.form[fieldName]?.$errors[0]?.$message) {
        return [v$.value.form[fieldName].$errors[0].$message];
      }

      return [];
    });

    const previewArticle = computed(() => {
      return {
        title: form.value.title,
        annotation: form.value.annotation,
        start: undefined,
        end: undefined,
        speaker: {
          name: form.value.name,
          photo_url: imageSource.value,
          position: form.value.position,
          web: correctHttps(form.value.web),
          linkedin: correctHttps(form.value.linkedin),
          twitter: correctHttps(form.value.twitter),
        },
      };
    });

    const delayTouch = (v$) => {
      v$.$reset();
      if (touchMap.has(v$)) {
        clearTimeout(touchMap.get(v$));
      }
      touchMap.set(v$, setTimeout(v$.$touch, 1000));
    };

    const getPresentationType = () => {
      if (form.value.talkType === "caseStudy") {
        return "caseStudy";
      }

      return form.value.type;
    };

    const correctHttps = (url) => {
      url = url ?? "";
      url = url.trim();
      if (
        url.length > 0 &&
        !url.startsWith("https://") &&
        !url.startsWith("http://")
      ) {
        return "https://" + url;
      }

      return url;
    };

    const onSubmit = async () => {
      v$.value.$touch();
      await v$.value.$validate();

      if (v$.$error) return;

      try {
        await recaptchaLoaded();

        const token = await executeRecaptcha();

        let data = { ...form.value };
        delete data.talkType;
        data.type = getPresentationType();
        data.recaptcha_token = token;
        data.twitter = correctHttps(data.twitter);
        data.web = correctHttps(data.web);
        data.linkedin = correctHttps(data.linkedin);

        if (isEditForm) {
          data.edit_token = edit_token.value;

          const res = await axios.post(
            route("happening.update", { happening: happening.id }),
            data
          );

          if (res.status === 200) {
            showSuccessMessage.value = true;
          } else {
            showErrorMessage.value = true;
          }
        } else {

          const standardRoute = route("happening.create");
          const adminRoute = '/api/happening/create-admin';
          let postUrl = standardRoute;

          if(isAdmin) {
            postUrl = adminRoute;
          }

          const res = await axios.post(postUrl, data);

          if (res.status === 200) {
            formSent.value = true;

            if(isAdmin) {
              alert("Vytvořena přednáška s ID " + res.data.id.toString());
              window.location.href = route('frontend.homepage');
            } else {
              window.location.href = route("frontend.happening-list", {
                happeningId: res.data.id,
              });
            }

          } else {
            showErrorMessage.value = true;
          }
        }
      } catch (err) {
        showErrorMessage.value = true;
      }
    };

    const openModal = () => {
      modalProgramArticle.value = { ...previewArticle.value };
    };

    return {
      getErrorsFor,
      v$,
      delayTouch,
      onSubmit,
      form,
      onImageAdded,
      onImageRemoved,
      onImagePreviewLoaded,
      previewArticle,
      showSuccessMessage,
      showErrorMessage,
      formSent,
      modalProgramArticle,
      openModal,
      isEditForm,
    };
  },
};
</script>

<style>
</style>
